import React from 'react';
import PropTypes from 'prop-types';

import OEToggle from './oe-toggle';
import {OECustomCheckbox} from './oe-checkbox';

export const OEToggleCheckboxStyle = {
    toogle:             'toogle',
    checkbox:           'checkbox'
};

export default class OEToggleCheckbox extends React.PureComponent {

    constructor(props) {
        super(props);
        this.onClick = this.onClick.bind(this);
    }

    onClick()   {
        if(this.props.onClick)    this.props.onClick(this, this.props.userData);
    }

    render() {
        return (this.props.style == OEToggleCheckboxStyle.toogle ?
            <OEToggle
                className={this.props.className}
                disabled={this.props.disabled}
                active={this.props.active}
                onClick={this.onClick}
            /> :
            <OECustomCheckbox
                className={this.props.className}
                icon={this.props.icon}
                uncheckedIcon={this.props.uncheckedIcon}
                disabled={this.props.disabled}
                checked={this.props.active}
                onPressed={this.onClick}
            />
        );
    }
}

OEToggleCheckbox.defaultProps = {
    className: '',
    style: OEToggleCheckboxStyle.checkbox,
    icon: '\uF00C',
    disabled: false,
    active: true
};

OEToggleCheckbox.propTypes = {
    className: PropTypes.string,
    style: PropTypes.oneOf(Object.keys(OEToggleCheckboxStyle)),
    icon: PropTypes.string,
    uncheckedIcon: PropTypes.string,
    disabled: PropTypes.bool,
    active: PropTypes.bool,
    onClick: PropTypes.func
};